import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { WorkspacePersonaService } from '../services/persona.service';
import { WorkspacePersona, SetPersonasRequest } from '../models/personas';

const mockWorkspacePersonas: WorkspacePersona[] = [
  {
    persona_id: 'sales-analyst-v1',
    type: 'editor',
    current_prompt:
      "You are an expert Sales Analyst. Your goal is to review the user's data and provide actionable insights to improve quarterly revenue."
  },
  {
    persona_id: 'marketing-viewer-v2',
    type: 'viewer',
    current_prompt:
      'You are a Marketing Manager interested in high-level summaries. Never generate code or deeply technical analysis.'
  },
  {
    persona_id: 'executive-summary-v1',
    type: 'viewer',
    current_prompt: 'You must summarize all information into 3 bullet points or less for an executive audience.'
  }
];

@Injectable()
export class MockWorkspacePersonaService extends WorkspacePersonaService implements WorkspacePersonaService {
  public override setWorkspacePersonas(workspaceId: string, data: SetPersonasRequest): Observable<void> {
    console.log(`MOCK: Setting personas for workspace ${workspaceId}. New IDs: ${data.persona_ids.join(', ')}`);
    return of(undefined).pipe(delay(2000));
  }

  public override getWorkspacePersonas(workspaceId: string): Observable<WorkspacePersona[]> {
    console.log(`MOCK: Retrieving personas for workspace ${workspaceId}`);
    return of([...mockWorkspacePersonas]).pipe(delay(2000));
  }
}
